const validations = {
	Conditional: require('./conditional').default,
	Required: require('./required').default,
	conditional: require('./conditional').default,
	required: require('./required').default,
};

export default validations;
